import * as $ from 'jquery';
import {safeLocalStorage} from './utils/safeLocalStorage.js';
import * as BI from './tracking/bi.js';
import { del, post } from './utils/ajax.js';

// Data models tracking (BI & Zendesk)
import { UserReviewCompleteBIModel } from './BI/models';

$(document).on('change', '.js-rating-input', function() {
	if ($(this).prop('checked')) {
		var val = $(this).val();
		document.querySelector('#invalid-' + this.name).style.display = "none";

		$(this).closest('.rating').find('.js-rating-icon').each(function() {
			if ($(this).data('val') <= val) {
				if ($(this).hasClass('icon-star-outline') || $(this).hasClass('icon-star-filled')) {
					$(this).removeClass('icon-star-outline').addClass('icon-star-filled');
				}
				if ($(this).hasClass('bg-grey-200') || $(this).hasClass('bg-primary-500')) {
					$(this).removeClass('bg-grey-200').addClass('bg-primary-500');
				}
			} else {
				if ($(this).hasClass('icon-star-outline') || $(this).hasClass('icon-star-filled')) {
					$(this).addClass('icon-star-outline').removeClass('icon-star-filled');
				}
				if ($(this).hasClass('bg-grey-200') || $(this).hasClass('bg-primary-500')) {
					$(this).addClass('bg-grey-200').removeClass('bg-primary-500');
				}
			}
		});
	}
});

const formTransaction = document.getElementById('transaction-rating-form');

if (formTransaction) {
	formTransaction.addEventListener('submit', (e) => {
		const target = e.target;

		let i = 0,
			gotErrors = false;

		while (i < 5) {
			if (document.querySelector('[name="starsDetailed' + i + '"]:checked') === null) {
				document.querySelector('#invalid-starsDetailed' + i).style.display = "block";
				gotErrors = true;
			}
			i++;
		}

		let $description = document.querySelector('[name="comment_rating"]');

		if ($description.value.length < 1) {
			$description.style.border = "1px solid red";
			gotErrors = true;
		}

		if (document.querySelector('[name="starsGlobal"]:checked') === null) {
			document.querySelector('#invalid-starsGlobal').style.display = "block";
			gotErrors = true;
		}

		if (gotErrors) {
			e.preventDefault();
		} else {
			const userId = target.dataset.biSellerId || null;
			const productId = target.dataset.biProductId || null;
			const shippingTime = document.querySelector('input[name="starsDetailed0"]:checked').value || null;
			const descriptionQuality = document.querySelector('input[name="starsDetailed1"]:checked').value || null;
			const communication = document.querySelector('input[name="starsDetailed2"]:checked').value || null;
			const productStatus = document.querySelector('input[name="starsDetailed3"]:checked').value || null;
			const packageStatus = document.querySelector('input[name="starsDetailed4"]:checked').value || null;
			const overallRating = document.querySelector('input[name="starsGlobal"]:checked').value || null;
			const comment = document.getElementsByName("comment_rating")[0].value || null;
			
			const userReviewCompleteBIModel = new UserReviewCompleteBIModel(userId, productId, shippingTime, descriptionQuality, communication, productStatus, packageStatus, overallRating, comment);
            BI.track(userReviewCompleteBIModel);
		}
	});
}

document.querySelectorAll('.js-show-bought-products').forEach(popover => {
	if (!safeLocalStorage.getItem('product-bought-popover')) {
		$(popover).popover('show');
	}
	$(popover).on('shown.bs.popover', () => safeLocalStorage.setItem('product-bought-popover', 'seen'));
});

if (document.body.classList.contains('js-rating-seller')) {
	const modalDeleteCommentSeller = document.getElementById('modal-delete-rating-comment');
	const btnDelete = modalDeleteCommentSeller?.querySelector('.js-comment-rating-seller-delete-btn');
	let transactionId = null;

	const deleteCommentRatingSeller = (id) => (del(`/api/v5/rating/${id}/reply`,{}, false, true).then(response => response));

	const addCommentRatingSeller = (id, comment) => (post(`/api/v5/rating/${id}/reply`, { comment }).then(response => response));

	$('#modal-delete-rating-comment').on('show.bs.modal', (e) => transactionId = e.relatedTarget.dataset.transactionId);

	btnDelete?.addEventListener('click', async () => {
		if (transactionId !== null) {
			await deleteCommentRatingSeller(transactionId);
			window.location.reload();
		}
	});

	document.querySelectorAll('.js-rating-reply-comment').forEach(reply => {
		const submitBtn = reply.querySelector('button');
		const textArea = reply.getElementsByTagName('textarea')[0];
		const transactionId = reply.dataset.transactionId;

		submitBtn?.addEventListener('click', async ()=> {
			if (textArea.value.length > 0) {
				submitBtn.setAttribute('disabled', '');
				await addCommentRatingSeller(transactionId, textArea.value);
				window.location.reload();
			}
		})
	});
}
